export default {
  size_chart: '',
}
